import { ethers } from "ethers";
import { ETHEREUM_ALCHEMY_API_KEY } from "../../config/env";

// Alchemy: setup Alchemy provider just for ENS purposes (so it's hardcoded to mainnet)
export const alchemyProvider = new ethers.providers.AlchemyProvider(
  "homestead",
  ETHEREUM_ALCHEMY_API_KEY,
);
